/**
 * Tiny pub/sub — subset of the former `mitt` API used in this app (`on` / `off` / `emit` only, no `*`).
 */
export type EventHandler = (payload?: unknown) => void

export function createEventEmitter (): {
  on: (type: string, handler: EventHandler) => void
  off: (type: string, handler?: EventHandler) => void
  emit: (type: string, payload?: unknown) => void
  } {
  const all = new Map<string, EventHandler[]>()

  return {
    on (type: string, handler: EventHandler) {
      const list = all.get(type)
      if (list) list.push(handler)
      else all.set(type, [handler])
    },

    off (type: string, handler?: EventHandler) {
      const list = all.get(type)
      if (!list) return
      if (handler) {
        const i = list.indexOf(handler)
        if (i >= 0) list.splice(i, 1)
      } else {
        all.set(type, [])
      }
    },

    emit (type: string, payload?: unknown) {
      const list = all.get(type)
      if (list) {
        for (const h of list.slice()) {
          h(payload)
        }
      }
    },
  }
}
